import { DateTime } from '@components/misc/dateTime/dateTime';
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineOppositeContent,
  TimelineSeparator,
} from '@mui/lab';
import { Chip, Dialog, DialogContent, DialogTitle } from '@mui/material';
import { Grid, Typography } from 'hephaestus/web';

const stateColor = (state: any) =>
  ['ACTIVE', 'RECONCILED', 'COMPLETED'].includes(state)
    ? 'success'
    : ['FAILED', 'CANCELED', 'FROZEN', 'INACTIVE'].includes(state)
      ? 'error'
      : ['INITIATED', 'CREATED'].includes(state)
        ? 'default'
        : 'warning';

const StateChangesModal = ({
  title,
  open,
  handleClose,
  stateChanges,
  children,
  id,
}: {
  title: string;
  open: boolean;
  handleClose: () => void;
  stateChanges: any[];
  children?: any;
  id: string;
}) => (
  <Dialog open={open} onClose={handleClose} maxWidth='sm' fullWidth>
    <DialogTitle>
      <Grid
        container
        sx={{
          justifyContent: 'space-between',
        }}
      >
        <Grid>
          <Typography variant='headingSmall'>{title}</Typography>
        </Grid>
        <Grid>
          <Typography variant='labelSmall'>{id}</Typography>
        </Grid>
      </Grid>
    </DialogTitle>
    <DialogContent>
      {children}
      <Timeline>
        {stateChanges?.map((event: any, index: number) => (
          <TimelineItem key={index}>
            <TimelineOppositeContent
              sx={{
                color: 'text.secondary',
              }}
            >
              <DateTime date={event.createdAt} />
            </TimelineOppositeContent>
            <TimelineSeparator>
              <TimelineDot />
              {stateChanges.length !== index + 1 && <TimelineConnector />}
            </TimelineSeparator>
            <TimelineContent>
              <Chip
                size='small'
                label={event.to}
                color={stateColor(event.to)}
              />
            </TimelineContent>
          </TimelineItem>
        ))}
      </Timeline>
    </DialogContent>
  </Dialog>
);

export default StateChangesModal;
